// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5X1VX","titleLink":"styles_titleLink__z9F+I","questionsWrapper":"styles_questionsWrapper__eeZPw","questionLink":"styles_questionLink__e2Bx-"};